import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const EventCard = ({ event }) => (
  <Link to={`/events/${event.slug}`} data-testid={`event-card-${event.slug}`} className="group block w-[260px] md:w-[280px] flex-shrink-0">
    <div className="card-on-orange rounded-md overflow-hidden">
      <div className="aspect-[4/5] overflow-hidden">
        <img
          src={event.image_url}
          alt={event.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="p-5">
        <p className="text-xs text-[#2D1810]/50 font-medium mb-2">
          {event.date} &middot; {event.time}
        </p>
        <h3 className="font-syne text-lg font-semibold text-[#2D1810] group-hover:text-[#A04D1F] transition-colors mb-1">
          {event.title}
        </h3>
        {event.tagline && (
          <p className="text-sm text-[#2D1810]/60 mb-3">{event.tagline}</p>
        )}
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[#A04D1F] group-hover:gap-2.5 transition-all">
          Get Tickets <ArrowRight size={14} />
        </span>
      </div>
    </div>
  </Link>
);
